import $ from 'jquery';
import { zoomIn, zoomOut, centerCanvas } from '~core';

export const enableZoomButtons = async () => {
  $('body').on('click', '#btn-zoom-less', zoomOut);
  $('body').on('click', '#btn-zoom-plus', zoomIn);
  $('body').on('click', '#btn-zoom-fill', centerCanvas);
  $('#editor-zoom-controls').show();
};
